import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import { FaBuilding, FaClipboardList, FaInfoCircle, FaArrowLeft } from 'react-icons/fa';
import Topbar from '../layouts/Topbar';
import Sidebar from '../layouts/Sidebar';
import './CreateDepartment.css';
import packageJson from '../../../../package.json';

const CreateDepartment = () => {
    const navigate = useNavigate();
    const baseUrl = 'https://api.burrayhr.com';
    const [loading, setLoading] = useState(false);
    const [companyInfo, setCompanyInfo] = useState(null);
    const [formData, setFormData] = useState({
        name: '',
        company: ''
    });
    const [errors, setErrors] = useState({});

    useEffect(() => {
        const fetchUserCompany = async () => {
            try {
                const token = localStorage.getItem('token');
                // In a real application, you would fetch the user's company from the API
                // For now, we'll simulate this data
                
                // Simulated API response
                const response = {
                    data: {
                        id: 1,
                        name: "Burray Technologies",
                        is_active: true
                    }
                };
                
                setCompanyInfo(response.data);
                setFormData(prev => ({
                    ...prev,
                    company: response.data.id
                }));
                
            } catch (error) {
                console.error('Error fetching user company:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Failed to fetch company information',
                    confirmButtonColor: '#1e3a8a'
                });
            }
        };

        fetchUserCompany();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
        
        // Clear error when user starts typing
        if (errors[name]) {
            setErrors({
                ...errors,
                [name]: null
            });
        }
    };

    const validateForm = () => {
        const newErrors = {};
        
        if (!formData.name.trim()) {
            newErrors.name = 'Department name is required';
        } else if (formData.name.length < 2) {
            newErrors.name = 'Department name must be at least 2 characters';
        }
        
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!validateForm()) {
            return;
        }
        
        setLoading(true);
        
        try {
            const token = localStorage.getItem('token');
            
            // In a real application, you would send the data to your API
            // For now, we'll simulate a successful response
            
            // Simulated API call
            await axios.post(`${baseUrl}/api/departments/`, formData, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            
            // Simulate API delay
            await new Promise(resolve => setTimeout(resolve, 1000));
            
            Swal.fire({
                icon: 'success',
                title: 'Success!',
                text: 'Department created successfully',
                confirmButtonColor: '#1e3a8a'
            });
            
            // Redirect to departments list
            navigate('/admin-manager/departments');
            
        } catch (error) {
            console.error('Error creating department:', error);
            
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.response?.data?.message || 'Failed to create department',
                confirmButtonColor: '#1e3a8a'
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <Topbar />
            <Sidebar />
            <div className="main-content">
                <div className="create-department-container">
                    <div className="page-header">
                        <div className="header-content">
                            <h1>
                                <FaBuilding style={{color: 'navy'}} className="" />
                                Create Department
                            </h1>
                            
                        </div>
                        <button 
                            className="back-button"
                            onClick={() => navigate('/admin-manager/departments')}
                        >
                            <FaArrowLeft /> Back to Departments
                        </button>
                    </div>
                    
                    <div className="department-container">
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label htmlFor="name">
                                    Department Name <span className="required">*</span>
                                </label>
                                <input
                                    type="text"
                                    id="name"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    placeholder="Enter department name"
                                    className={errors.name ? 'error' : ''}
                                />
                                {errors.name && (
                                    <div className="error-message">
                                        <FaInfoCircle /> {errors.name}
                                    </div>
                                )}
                            </div>
                            
                            <div className="form-actions">
                                <button
                                    type="button"
                                    className="cancel-button"
                                    onClick={() => navigate('/admin-manager/departments')}
                                    disabled={loading}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="submit-button"
                                    disabled={loading}
                                >
                                    {loading ? (
                                        <>
                                            <span className="spinner-border"></span>
                                            Creating...
                                        </>
                                    ) : (
                                        <>
                                            <FaClipboardList /> Create Department
                                        </>
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CreateDepartment;